import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface MinimumOrderQuantityEntityParams {
  label: string;
  units: number;
  cases: number;
  sleeves: number;
  sku: string;
  messaging_type: string;
}

export class MinimumOrderQuantityEntity extends BaseEntityClass {
  label: string;
  units: number;
  cases: number;
  sleeves: number;
  sku: string;
  messaging_type: string;

  constructor(params: MinimumOrderQuantityEntityParams) {
    super();
    this.type = "minimum_order_quantity";
    this.entity_version = 2;
    this.label = params.label;
    this.units = params.units;
    this.cases = params.cases;
    this.sleeves = params.sleeves;
    this.sku = params.sku;
    this.messaging_type = params.messaging_type;
  }
}
